import script from "./MatchinPayPaymentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchinPayPaymentPage.vue?vue&type=script&setup=true&lang=js"

import "./MatchinPayPaymentPage.vue?vue&type=style&index=0&id=9d334c58&lang=css"

export default script